module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2015/october-6ca3a7de5d815e3c2d57a964b34a0508.png";